import { QuestionVariety } from "./Definition";
import { SingleValueQuestion } from "./SingleValueQuestion";

export default class RadiosQuestion extends SingleValueQuestion {
  get type(): QuestionVariety {
    return "radios";
  }
}
